<!-- Translated: skip -->
<template>
  <Modal @close="localClose" :wide="false" :show-close="false" class="center" width="400px">

    <p><b>Du har redan ett boende i varukorgen</b></p>

    <h1 v-if="accomodation && accomodation.name" class="accomodation-title">{{accomodation.name}}</h1>

    <AccomodationPeriodConfirm v-if="accomodation" :unit="unit" :arrival="arrival" :departure="departure" :small="true"></AccomodationPeriodConfirm>

    <hr />
    <p>Om du vill boka flera boenden i samma bokning måste du välja samma datum.</p>
    <p v-if="!is_free">Den valda perioden är dock inte tillgänglig för detta boende.</p>
    <hr />

    <button class="small" @click="goToInfo" v-if="is_free">Okej, gå vidare och boka</button>
    <button class="small" @click="goToSearch" v-if="!is_free">Okej, gå tillbaka till sök</button>
    <div style="height:5px;"></div>
    <button class="small white border" @click="goToSearch" v-if="is_free">Tillbaka</button>
    <button class="small white border" @click="goToCart">Avbryt och gå till varukorg</button>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import API from '@/classes/API';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    AccomodationPeriodConfirm,
  },
  data() {
    return {
      peopleCount: 1,
      accomodation: null,
      unit: {},
      arrival: '',
      departure: '',
      accomodations: [],
      is_free: false,
    };
  },
  async mounted() {
    const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
    const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

    if (confirmed.length) {
      this.accomodation = confirmed[0];
      this.accomodations = confirmed;
    } else if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
      this.accomodation = {
        poolLid: this.$store.state.cart.addToOrder.helperPool,
        unitLid: this.$store.state.cart.addToOrder.helperUnit,
        period: {
          date_arrival: this.$store.state.cart.addToOrder.dateStart,
          date_departure: this.$store.state.cart.addToOrder.dateEnd,
        },
      };
    }

    if (this.accomodation) {
      this.unit = {
        pool_lid: this.accomodation.poolLid,
        unit_lid: this.accomodation.unitLid,
      };
      this.arrival = this.accomodation.period.date_arrival;
      this.departure = this.accomodation.period.date_departure;

      const { free } = await API.get(`/units/${this.params.unitPreview.pool_lid}/${this.params.unitPreview.unit_lid}/is_free/${this.arrival}/${this.departure}`);
      this.is_free = free;
    }
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'openModal',
      'addRentalPeople',
      'confirmedAccomodations',
      'closeAllModals',
    ]),
    goToCart() {
      this.closeModal();
      this.$router.push({ path: '/varukorg' });
    },
    goToInfo() {
      this.closeModal();
      // const flow = encodeURI(this.$route.fullPath);
      this.$router.push({
        path: `/boenden/info/${this.$route.params.slug}/${this.arrival}/${this.departure}?no=-1`,
      });
    },
    goToSearch() {
      this.closeModal();
      this.$router.push({ name: 'accomodation list' });
    },
    localClose() {
      return false;
      // this.closeModal();
      // this.$router.push({ name: 'accomodation list' });
      // window.history.go(-1);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

p
  margin-bottom 15px
  margin-top 15px
hr
  border: solid 1px #deebf0;
  margin-top 15px
  margin-bottom 15px

h1.accomodation-title
  font-size 19px
  font-weight bold
  text-align center
  color #262626
  text-transform none
  border-radius 2px
  background-color #ecf5f8
  border solid 1px #bfd9e1
  padding 7px 20px
  display inline-block
</style>



// WEBPACK FOOTER //
// SecondAccomodationModal.vue?69d9c991